<template>
  <div
    v-if="entries.length"
    class="flex flex-wrap justify-center gap-2 px-3 @3xs/menu:justify-start"
    data-testid="partner-menu-links"
  >
    <RouterLink
      v-for="entry in entries"
      :key="entry.id"
      :to="entry.route"
      :title="entry.label"
      class="flex aspect-square w-10 items-center justify-center squircle-md rounded bg-white p-1 shadow-xl"
    >
      <img :src="entry.img.src" :alt="entry.label" />
    </RouterLink>
  </div>
</template>

<script>
import { partnerMenuEntries } from '@/views/layouts/main-layout/partnerMenuEntries'

export default {
  name: 'PartnerMenuLinks',
  computed: {
    entries() {
      return partnerMenuEntries((module) =>
        this.$functionality.module.has(module)
      )
    }
  }
}
</script>
